<script lang="ts" setup>
withDefaults(
  defineProps<{
    labelText?: string | null
    isRight?: boolean
  }>(),
  { labelText: null, isRight: false }
)

const checked = defineModel<boolean>({
  default: false
})
</script>

<template>
  <label class="flex cursor-pointer items-center">
    <span v-if="!isRight && labelText" class="mr-2">{{ labelText }}</span>

    <input v-model="checked" class="hidden" type="checkbox">

    <span class="flex size-[21px] items-center justify-center">
      <svg
        v-if="checked"
        fill="none"
        height="21"
        viewBox="0 0 20 21"
        width="20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          fill="#59AD3B"
          height="19"
          rx="3.5"
          width="19"
          x="0.5"
          y="1.36841"
        />
        <rect
          height="19"
          rx="3.5"
          stroke="#59AD3B"
          width="19"
          x="0.5"
          y="1.36841"
        />
        <path d="M5 9.86841L9 14.3684L15.5 5.86841" stroke="white" stroke-width="2" />
      </svg>
      <svg
        v-else
        fill="none"
        height="21"
        viewBox="0 0 21 21"
        width="21"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          height="19"
          rx="3.5"
          stroke="#E2E2E2"
          width="19"
          x="1.38281"
          y="0.518555"
        />
      </svg>
    </span>

    <span v-if="isRight && labelText" class="ml-2">{{ labelText }}</span>
  </label>
</template>
